/**
 * Route element wrappers for settings pages under /admin/ hub structure.
 *
 * Each wrapper passes a `view` prop to the existing page component so it
 * shows only the relevant section with the right header and back-navigation.
 */

// Existing page components — now with view prop support
import { OrgSettingsPage } from '../org/OrgSettingsPage';
import { OrgManageUsersPage } from './OrgManageUsersPage';
import { ManageBillingPage } from './ManageBillingPage';
import { ManagePlanPage } from './ManagePlanPage';
import { ManagePaymentsPage } from './ManagePaymentsPage';
import { OrgResourceRatesPage } from '../org/OrgResourceRatesPage';
import { ResidentialDefaultsPage } from './ResidentialDefaultsPage';
import { OrgInventoryPage } from './OrgInventoryPage';
import { OrgServicesPage } from './OrgServicesPage';
import { CustomerPaymentsPage } from './CustomerPaymentsPage';
import { OnlineLeadsSettingsPage } from './OnlineLeadsSettingsPage';
import { ManageFleetPage } from '../org/ManageFleetPage';
import { ManageWarehousesPage } from './ManageWarehousesPage';
import { IntegrationsPage } from './IntegrationsPage';
import { useUserProfile } from '../../context/UserProfileContext';

// ── Company Hub ─────────────────────────────────────────────────────────────

export function CompanyUsersPage() {
  return <OrgManageUsersPage />;
}

export function CompanyBillingPage() {
  return <ManageBillingPage />;
}

export function CompanyBillingPlanPage() {
  return <ManagePlanPage />;
}

export function CompanyBillingPaymentsPage() {
  return <ManagePaymentsPage />;
}

// ── Quoting Hub ─────────────────────────────────────────────────────────────

export function QuotingQuoteDefaultsPage() {
  const { adminOrg } = useUserProfile();
  return <OrgSettingsPage view="quote-defaults" contextOrgId={adminOrg?.orgId} />;
}

export function QuotingRateCardsPage() {
  return <OrgResourceRatesPage />;
}

export function QuotingResidentialRoomsPage() {
  return <ResidentialDefaultsPage />;
}

export function QuotingInventoryItemsPage() {
  return <OrgInventoryPage />;
}

export function QuotingServicesPage() {
  return <OrgServicesPage />;
}

// ── Payments Hub ────────────────────────────────────────────────────────────

export function PaymentsMethodsPage() {
  return <CustomerPaymentsPage view="methods" />;
}

export function PaymentsSchedulePage() {
  return <CustomerPaymentsPage view="schedule" />;
}

// ── Customer-Facing Hub ─────────────────────────────────────────────────────

export function CustomerFacingBookingFormPage() {
  return <OnlineLeadsSettingsPage view="booking" />;
}

export function CustomerFacingOnlineQuotesPage() {
  return <OnlineLeadsSettingsPage view="quotes" />;
}

// ── Operations Hub ──────────────────────────────────────────────────────────

export function OperationsManageFleetPage() {
  return <ManageFleetPage />;
}

export function OperationsManageWarehousesPage() {
  return <ManageWarehousesPage />;
}

// ── Platform Hub ────────────────────────────────────────────────────────────

export function PlatformFeaturesPage() {
  return <IntegrationsPage view="features" />;
}

export function PlatformIntegrationsPage() {
  return <IntegrationsPage view="integrations" />;
}
